var map = {
	"./Group.svg": 9133,
	"./account.svg": 2449,
	"./actions.svg": 1269,
	"./arrow-left.svg": 1307,
	"./bitbucket.svg": 7695,
	"./claude.svg": 962,
	"./cline.svg": 3293,
	"./clipboard.svg": 3718,
	"./configure.svg": 5912,
	"./connect.svg": 5390,
	"./copy.svg": 8619,
	"./cursor.svg": 202,
	"./default-tool.svg": 9498,
	"./filter-search.svg": 5343,
	"./github.svg": 2081,
	"./gitlab.svg": 5369,
	"./google.svg": 4601,
	"./history.svg": 7532,
	"./jira.svg": 2136,
	"./logout.svg": 1582,
	"./mcp-logo.svg": 9896,
	"./microsoft.svg": 3288,
	"./more.svg": 9951,
	"./repeat-circle.svg": 734,
	"./rotate-right.svg": 6736,
	"./slack.svg": 9708,
	"./support-graphic.svg": 8386,
	"./support.svg": 97,
	"./teams.svg": 8310,
	"./test.svg": 5080,
	"./tools.svg": 4877,
	"./trash.svg": 242,
	"./usage.svg": 9233,
	"./vscode.svg": 2354,
	"./windsurf.svg": 3902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3222;